export default __webpack_public_path__ + "static/media/particles-web-theme5.dd968eff.svg";